export const api='https://tiktok-3pv4.onrender.com/api'
export const verifyemailURL=`${api}/v3/verify/email`
export const verifyphoneURL=`${api}/v3/verify/phone`
export const sendOTPemailURL=`${api}/v3/send-otp/email`
export const sendOTPphoneURL=`${api}/v3/send-otp/phone`
export const checkuserURL=`${api}/v3/check/user`
export const registerURL=`${api}/v3/register`
export const loginURL=`${api}/v3/login`
export const userinfoURL=`${api}/v3/user/info`
export const videouserURL=`${api}/v3/video/user`
export const uploadvideoURL=`${api}/v3/user/uploadvideo`
export const listuploadvideoURL=`${api}/v3/video/list`
export const commentreplyURL=`${api}/v3/comment/reply`
export const listcommentURL=`${api}/v3/comment/list`
export const actionvideoURL=`${api}/v3/video/action`
export const listcommentreplyURL=`${api}/v3/comment/replylist`
export const listfollowingURL=`${api}/v3/user/upload/following`
export const listfollowingcommentURL=`${api}/v3/user/comment/following`
export const followinguserURL=`${api}/v3/follow/user`
export const listhagtagURL=`${api}/v3/user/hashtag`
export const listmusicURL=`${api}/v3/music/list`
export const actioncommentURL=`${api}/v3/commnet`
export const userprofileURL=`${api}/v3/user/profile`
export const userseachURL=`${api}/v3/user/search`
export const videoseachURL=`${api}/v3/video/search`
export  const searchinputURL=`${api}/v3/search/input`
export  const videodetailURL=`${api}/v3/user/video`
export const suggestedaccountURL=`${api}/v3/account/suggested`
export const notifycationURL=`${api}/v3/notifycation/user`
export const videoloadURL=`${api}/v3/video/load`
export const paymentURL=`${api}/v3/payment`
export const hashtagURL=`${api}/v3/hashtag`
export const videotagURL=`${api}/v3/hashtag/video`
export const listvideorecommendURL=`${api}/v3/list/video/recommend`
export const listvideofollowingURL=`${api}/v3/list/video/following`
export const listrecomendbrowserURL=`${api}/v3/list/video/browser`
// live
export const listcategoriesURL=`${api}/v2/categories/`
export const sendcoinURL=`${api}/v2/give/coin`
export const newstreamURL=`${api}/v2/newstream/`
export const  mystreamURL=`${api}/v2/mystream/`
export const actionMessageURL=`${api}/v2/message`
export const  messageliveURL=`${api}/v2/streams/`
export const coinuserURL=`${api}/v2/user/stream/coins`
//chat
const apichat=`${api}/v1`
export const conversationsURL=`${apichat}/conversations/`
export const threadlURL=`${apichat}/message`;
export const listThreadlURL=`${apichat}/thread/list`
